export default [
    // {
    //     id: 1,
    //     label: {
    //         en: 'Estimate ready',
    //         et: 'Hinnapakkumine valmis',
    //         ru: 'Ценовое предложение готово'
    //     }
    // },
    {
        id: 3,
        label: {
            en: 'Appointment reminder',
            et: 'Aja meeldetuletus',
            ru: 'Напоминание о визите',
            lv: "Vizītes atgādinājums",
            lt: "Priminimas apie vizitą",
            fi: "Ajanvarausmuistutus",
            // en: 'Appointment',
            // et: 'Aeg',
            // ru: 'Визит'
        }
    },
    // {
    //     id: 5,
    //     label: {
    //         en: 'Order ready',
    //         et: 'Tellimus valmis',
    //         ru: 'Заказ готов'
    //     }
    // },
    {
        id: 7,
        label: {
            en: 'Maintenance reminder',
            et: 'Hoolduse meeldetuletus',
            ru: 'Напоминание о ТО',
            lv: "Apkopes atgādinājums",
            lt: "Priminimas apie techninę priežiūrą",
            fi: "Huoltomuistutus",
            // en: 'Maintenance',
            // et: 'Hooldus',
            // ru: 'Тех. обслуживание'
        }
    },
]